// pages/EditSearchActivityPage.js
import React, { useEffect, useState } from 'react';
import { useParams, useNavigate } from 'react-router-dom';
import { doc, getDoc, updateDoc } from 'firebase/firestore';
import { db } from '../services/firebase';
import SearchActivityForm from '../components/SearchActivityForm';
import { FaArrowLeft } from 'react-icons/fa';

function EditSearchActivityPage() {
  const { searchId } = useParams();
  const navigate = useNavigate();
  const [formData, setFormData] = useState(null);
  const [position, setPosition] = useState(null);
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    const fetchActivity = async () => {
      const ref = doc(db, 'search_activities', searchId);
      const snap = await getDoc(ref);
      if (snap.exists()) {
        const data = snap.data();
        setFormData({
          activityType: data.activityType,
          radius: data.preferredRadiusKm,
          dateRange: [
            new Date(data.preferredTime.dateRange.from),
            new Date(data.preferredTime.dateRange.to)
          ],
          hourRange: [
            data.preferredTime.hourRange.from,
            data.preferredTime.hourRange.to
          ],
          numberOfPeople: data.numberOfPeople
        });
        setPosition(data.preferredLocation);
      }
    };
    fetchActivity();
  }, [searchId]);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);

    const updated = {
      activityType: formData.activityType,
      preferredLocation: {
        lat: position.lat,
        lng: position.lng
      },
      preferredRadiusKm: parseInt(formData.radius),
      preferredTime: {
        dateRange: {
          from: formData.dateRange[0].toISOString(),
          to: formData.dateRange[1].toISOString()
        },
        hourRange: {
          from: formData.hourRange[0],
          to: formData.hourRange[1]
        }
      },
      numberOfPeople: formData.numberOfPeople
    };

    try {
      await updateDoc(doc(db, 'search_activities', searchId), updated);
      navigate(`/search_detail/${searchId}`);
    } catch (err) {
      console.error('Error updating activity:', err);
    } finally {
      setLoading(false);
    }
  };

  if (!formData) return <div className="container mt-5">Loading...</div>;

  return (
    <>
      <div className="container mt-4">

        <div className="d-flex align-items-center mb-4">
          <button
            type="button"
            className="btn btn-outline-primary me-3 d-flex align-items-center"
            onClick={() => navigate(-1)}
          >
            <FaArrowLeft className="me-2" />
            Back
          </button>
          <h4 className="mb-0">Edit Search Activity</h4>
        </div>

        <SearchActivityForm
          formData={formData}
          setFormData={setFormData}
          position={position}
          setPosition={setPosition}
          handleSubmit={handleSubmit}
          loading={loading}
        />
      </div>
    </>

  );
}

export default EditSearchActivityPage;
